<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 24 24">
    <path
      d="M12.0008 16.9137L4.1508 9.06368L4.8608 8.35368L12.0108 15.5037L19.1508 8.35368L19.8608 9.06368L12.0108 16.9137L12.0008 16.9137Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2144 9.06368L12.1144 17.1637L11.8972 17.1637L3.79725 9.06368L4.8608 8.00012L12.0107 15.15L19.1507 8L20.2144 9.06368ZM19.1509 8.70735L12.0109 15.8574L4.8608 8.70723L4.50436 9.06368L12.0058 16.5651L19.5072 9.06368L19.1509 8.70735Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
